import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../../global/unApi";
import Authorize from "../../../../global/Authorize";
import noData from "../../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ViewAtt extends Component {
  state = {
    dateToday: new Date(),
    dateValue: null,
    attendence: [],
    loading: true,
  };
  componentDidMount = () => {
    this.setState({
      dateValue: `${this.state.dateToday.getFullYear()}-${
        this.state.dateToday.getMonth > 9 ? "" : "0"
      }${
        this.state.dateToday.getMonth() + 1
      }-${this.state.dateToday.getDate()}`,
    });

    this.fetchAttendence({
      date: this.props.match.params.date,
      student_class: this.props.match.params.classs,
      section: this.props.match.params.section,
      session: this.props.user.session.id,
    });
  };

  fetchAttendence = (params = {}) => {
    axios
      .get("/appApi/appstudentattendancedaywise", { params: { ...params } })
      .then((res) => {
        this.setState({ attendence: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    this.setState({ dateValue: e.target.value, loading: true });

    this.fetchAttendence({
      date: e.target.value,
      student_class: this.props.match.params.classs,
      section: this.props.match.params.section,
      session: this.props.user.session.id,
    });
  };

  render() {
    const { dateToday } = this.state;
    return (
      <Authorize roles={["IS_TEACHER", "IS_PRINCIPAL"]} redirect to="/">
        <Header
          to="/profile"
          title={`${this.props.match.params.classname}-${this.props.match.params.sectionname}`}
        />

        <div className="container">
          <div className="th-14 th-bold mt-3">Select Month</div>
          <div className="input-group input-group mb-3">
            <input
              className="form-control th-input-primary th-12"
              type="date"
              value={this.state.dateValue}
              onChange={this.handleDateChange}
              max={`${dateToday.getFullYear()}-${
                dateToday.getMonth > 9 ? "" : "0"
              }${dateToday.getMonth() + 1}-${dateToday.getDate()}`}
            ></input>
          </div>
        </div>

        {this.state.attendence?.length !== 0 && this.state.loading ? null : (
          <table class="table table-striped th-12">
            <thead>
              <tr>
                <td className="th-medium">Roll no</td>
                <td className="th-medium">Student Name</td>
                <td className="th-medium">Attendance</td>
              </tr>
            </thead>
            <tbody>
              {this.state.attendence?.map((item, index) => {
                var status;
                if (item.attendence_status === "present") status = "P";
                else if (item.attendence_status === "absent") status = "A";
                else if (item.attendence_status === "halfday") status = "HD";
                else if (item.attendence_status === "late") status = "L";
                else if (item.attendence_status === "holiday") status = "H";
                return (
                  <tr>
                    <td>{item.student_info__roll_no}</td>
                    <td>{item.student_info__user__first_name}</td>
                    <td>{status}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        {this.state.loading ? (
          <div>
            <Skeleton width={150} />
            <Skeleton count={5} />
          </div>
        ) : null}

        {this.state.attendence?.length === 0 && this.state.loading === false ? (
          <div className="px-5 py-5">
            <img className="w-100 mt-5" src={noData} alt="No Data Found" />
            <p className="text-center th-14 th-bold mt-5">
              No Attendance Data Found!
            </p>
          </div>
        ) : null}
        <div style={{ height: "25vh" }}></div>
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(ViewAtt));
